import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "min-h-screen" }
const _hoisted_2 = { class: "w-full max-w-[760px] overflow-hidden rounded-xl border border-slate-200 bg-white shadow-2xl" }
const _hoisted_3 = { class: "flex items-start justify-between gap-4 border-b border-slate-200 px-5 py-4" }
const _hoisted_4 = { class: "text-lg font-bold text-slate-900" }
const _hoisted_5 = { class: "max-h-[75vh] overflow-y-auto bg-white" }
const _hoisted_6 = { class: "divide-y divide-slate-100" }
const _hoisted_7 = { class: "grid grid-cols-1 gap-3 px-5 py-4 md:grid-cols-[200px_1fr] md:items-start" }
const _hoisted_8 = { class: "grid grid-cols-1 gap-3 px-5 py-4 md:grid-cols-[200px_1fr] md:items-start" }
const _hoisted_9 = { class: "grid grid-cols-1 gap-3 px-5 py-4 md:grid-cols-[200px_1fr] md:items-start" }
const _hoisted_10 = { class: "inline-flex items-center gap-2 rounded-lg border border-slate-200 bg-slate-50 px-3 py-2 text-sm font-medium text-slate-700 hover:bg-slate-100 transition-colors cursor-pointer" }
const _hoisted_11 = { class: "flex items-center justify-end gap-3 border-t border-slate-200 bg-slate-50 px-5 py-4" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { class: "mt-8 space-y-5" }
const _hoisted_14 = { class: "relative overflow-hidden rounded-2xl bg-[#003793] p-4 text-white shadow-sm sm:p-6" }
const _hoisted_15 = { class: "relative flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between" }
const _hoisted_16 = { class: "grid grid-cols-1 gap-4 sm:grid-cols-3" }
const _hoisted_17 = { class: "rounded-2xl border border-slate-200 bg-white p-5 shadow-sm" }
const _hoisted_18 = { class: "mt-3 text-3xl font-bold text-slate-900" }
const _hoisted_19 = { class: "rounded-2xl border border-slate-200 bg-white p-5 shadow-sm" }
const _hoisted_20 = { class: "mt-3 text-3xl font-bold text-emerald-600" }
const _hoisted_21 = { class: "rounded-2xl border border-slate-200 bg-white p-5 shadow-sm" }
const _hoisted_22 = { class: "mt-3 text-3xl font-bold text-slate-400" }
const _hoisted_23 = { class: "rounded-2xl border border-slate-200 bg-white p-4 shadow-sm" }
const _hoisted_24 = { class: "grid gap-3 sm:grid-cols-2 lg:grid-cols-3" }
const _hoisted_25 = { class: "relative" }
const _hoisted_26 = { class: "overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm" }
const _hoisted_27 = { class: "flex flex-col gap-3 border-b border-slate-100 px-4 py-4 sm:flex-row sm:items-center sm:justify-between sm:px-5" }
const _hoisted_28 = { class: "text-xs text-slate-500" }
const _hoisted_29 = { class: "overflow-x-auto" }
const _hoisted_30 = { class: "min-w-full text-sm" }
const _hoisted_31 = { class: "divide-y divide-slate-100 bg-white" }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { class: "px-4 py-4 font-bold text-slate-900" }
const _hoisted_35 = { class: "px-4 py-4" }
const _hoisted_36 = { class: "font-mono text-sm font-bold bg-slate-100 px-2 py-1 rounded border border-slate-200 text-slate-600" }
const _hoisted_37 = { class: "px-4 py-4" }
const _hoisted_38 = { class: "px-4 py-4 text-center" }
const _hoisted_39 = { class: "flex items-center justify-center gap-1" }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = ["onClick"]

import { ref, computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import Swal from 'sweetalert2';
import Breadcrumb from '@/components/AppBreadcrumb.vue';
import AppSelect from '@/components/input/AppSelect.vue';
import IcEdit from '@/assets/svg/ic-edit.vue';
import IcTrash from '@/assets/svg/ic-trash.vue';
import IcPlus from '@/assets/svg/ic-plus.vue';
import {
  GET_FAKULTAS,
  POST_FAKULTAS,
  PUT_FAKULTAS,
  DELETE_FAKULTAS,
  Fakultas,
} from '@/store/fakultas.module';
import type { ApiErrorResponse } from '@/types/domain';


export default /*@__PURE__*/_defineComponent({
  __name: 'FakultasView',
  setup(__props) {

const store = useStore();
const isLoading = ref(true);
const isModalOpen = ref(false);
const isSubmitting = ref(false);
const editingId = ref<number | null>(null);
const form = ref({ name: '', kodeUnik: '', isActive: true });
const search = ref('');
const statusFilter = ref('');
const statusFilterOptions = [
  { value: '', label: 'Semua status' },
  { value: 'active', label: 'Aktif' },
  { value: 'inactive', label: 'Nonaktif' },
];

const fakultasList = computed<Fakultas[]>(() => store.getters.fakultas || []);
const activeCount = computed(() => fakultasList.value.filter((item) => item.isActive).length);
const inactiveCount = computed(() => fakultasList.value.length - activeCount.value);
const filteredFakultasList = computed(() => {
  const keyword = search.value.trim().toLowerCase();

  return fakultasList.value.filter((item) => {
    const matchKeyword = keyword
      ? `${item.name} ${item.kodeUnik}`.toLowerCase().includes(keyword)
      : true;
    const matchStatus = statusFilter.value === 'active'
      ? item.isActive
      : statusFilter.value === 'inactive'
        ? !item.isActive
        : true;

    return matchKeyword && matchStatus;
  });
});

const load = async () => {
  isLoading.value = true;
  try {
    await store.dispatch(GET_FAKULTAS);
  } finally {
    isLoading.value = false;
  }
};

onMounted(load);

const openCreate = () => {
  editingId.value = null;
  form.value = { name: '', kodeUnik: '', isActive: true };
  isModalOpen.value = true;
};

const openEdit = (item: Fakultas) => {
  editingId.value = item.id;
  form.value = { name: item.name, kodeUnik: item.kodeUnik, isActive: item.isActive };
  isModalOpen.value = true;
};

const closeModal = () => {
  isModalOpen.value = false;
};

const handleSubmit = async () => {
  isSubmitting.value = true;
  try {
    if (editingId.value) {
      await store.dispatch(PUT_FAKULTAS, { id: editingId.value, data: form.value });
    } else {
      await store.dispatch(POST_FAKULTAS, { data: form.value });
    }
    closeModal();
    await load();
  } catch (err: unknown) {
    const apiError = err as ApiErrorResponse;
    Swal.fire({ icon: 'error', title: 'Gagal', text: apiError?.message || 'Gagal menyimpan fakultas' });
  } finally {
    isSubmitting.value = false;
  }
};

const handleDelete = async (item: Fakultas) => {
  const result = await Swal.fire({
    title: `Hapus ${item.name}?`,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#dc2626',
    cancelButtonColor: '#6b7280',
    confirmButtonText: 'Ya, hapus',
    cancelButtonText: 'Batal',
  });
  if (!result.isConfirmed) return;
  try {
    await store.dispatch(DELETE_FAKULTAS, { id: item.id });
    await load();
  } catch (err: unknown) {
    const apiError = err as ApiErrorResponse;
    Swal.fire({ icon: 'error', title: 'Gagal', text: apiError?.message || 'Gagal menghapus fakultas' });
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Breadcrumb, { breadcrumb: "fakultas" }),
    (isModalOpen.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "fixed inset-0 z-[999] flex items-center justify-center p-4 backdrop-blur-sm bg-slate-900/50",
          onClick: _withModifiers(closeModal, ["self"])
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", null, [
                _createElementVNode("h3", _hoisted_4, _toDisplayString(editingId.value ? 'Edit' : 'Tambah') + " Fakultas", 1),
                _cache[5] || (_cache[5] = _createElementVNode("p", { class: "mt-1 text-sm text-slate-500" }, "Kode unik dipakai pada pembayaran donasi dan iuran manual.", -1))
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "rounded-lg p-1.5 text-slate-400 transition hover:bg-slate-100 hover:text-slate-700",
                onClick: closeModal
              }, [...(_cache[6] || (_cache[6] = [
                _createElementVNode("svg", {
                  class: "h-5 w-5",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  stroke: "currentColor"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M6 18L18 6M6 6l12 12"
                  })
                ], -1)
              ]))])
            ]),
            _createElementVNode("form", {
              onSubmit: _withModifiers(handleSubmit, ["prevent"])
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _cache[7] || (_cache[7] = _createElementVNode("div", null, [
                      _createElementVNode("label", { class: "text-sm font-semibold text-slate-900" }, [
                        _createTextVNode("Nama Fakultas "),
                        _createElementVNode("span", { class: "text-red-500" }, "*")
                      ]),
                      _createElementVNode("p", { class: "mt-0.5 text-xs text-slate-400" }, "Nama lengkap atau singkatan fakultas/prodi.")
                    ], -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.name) = $event)),
                      class: "block w-full rounded-lg border border-slate-200 bg-slate-50 px-3 py-2 text-sm text-slate-800 focus:border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-500/20",
                      placeholder: "mis. FTI",
                      required: ""
                    }, null, 512), [
                      [_vModelText, form.value.name]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _cache[8] || (_cache[8] = _createElementVNode("div", null, [
                      _createElementVNode("label", { class: "text-sm font-semibold text-slate-900" }, [
                        _createTextVNode("Kode Unik "),
                        _createElementVNode("span", { class: "text-red-500" }, "*")
                      ]),
                      _createElementVNode("p", { class: "mt-0.5 text-xs text-slate-400" }, "Maksimal 3 digit angka unik.")
                    ], -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.kodeUnik) = $event)),
                      maxlength: "3",
                      class: "block w-full rounded-lg border border-slate-200 bg-slate-50 px-3 py-2 font-mono text-sm font-bold text-slate-800 focus:border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-500/20",
                      placeholder: "001",
                      required: ""
                    }, null, 512), [
                      [_vModelText, form.value.kodeUnik]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _cache[10] || (_cache[10] = _createElementVNode("div", null, [
                      _createElementVNode("label", { class: "text-sm font-semibold text-slate-900" }, "Visibilitas"),
                      _createElementVNode("p", { class: "mt-0.5 text-xs text-slate-400" }, "Tampilkan sebagai pilihan aktif di form donasi.")
                    ], -1)),
                    _createElementVNode("label", _hoisted_10, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.isActive) = $event)),
                        class: "h-4 w-4 rounded border-slate-300 text-blue-700 focus:ring-blue-500"
                      }, null, 512), [
                        [_vModelCheckbox, form.value.isActive]
                      ]),
                      _cache[9] || (_cache[9] = _createTextVNode(" Status Aktif ", -1))
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("button", {
                  type: "button",
                  class: "rounded-lg border border-slate-200 bg-white px-4 py-2 text-sm font-medium text-slate-600 hover:bg-slate-100 transition-colors",
                  onClick: closeModal
                }, "Batal"),
                _createElementVNode("button", {
                  type: "submit",
                  class: "rounded-lg bg-[#003793] px-6 py-2 text-sm font-bold text-white shadow-sm hover:bg-blue-800 transition-all disabled:cursor-not-allowed disabled:opacity-60",
                  disabled: isSubmitting.value
                }, _toDisplayString(isSubmitting.value ? 'Menyimpan...' : editingId.value ? 'Simpan Perubahan' : 'Tambah Fakultas'), 9, _hoisted_12)
              ])
            ], 32)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("section", _hoisted_14, [
        _cache[13] || (_cache[13] = _createElementVNode("div", { class: "absolute -right-10 -top-12 h-40 w-40 rounded-full bg-white opacity-10" }, null, -1)),
        _cache[14] || (_cache[14] = _createElementVNode("div", { class: "absolute bottom-0 right-20 h-24 w-24 rounded-full bg-blue-300 opacity-10" }, null, -1)),
        _createElementVNode("div", _hoisted_15, [
          _cache[12] || (_cache[12] = _createElementVNode("div", null, [
            _createElementVNode("h1", { class: "text-2xl font-bold md:text-4xl" }, "Fakultas"),
            _createElementVNode("p", { class: "mt-2 max-w-2xl text-sm leading-relaxed text-blue-100" }, " Kelola daftar kode unik fakultas untuk referensi donasi dan iuran orang tua mahasiswa. ")
          ], -1)),
          _createElementVNode("button", {
            class: "inline-flex w-full items-center justify-center gap-2 rounded-full bg-white px-5 py-2.5 text-sm font-bold text-[#003793] shadow-lg transition-all hover:-translate-y-px hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-white/70 sm:w-auto",
            onClick: openCreate
          }, [
            _createVNode(IcPlus, { class: "w-4 h-4" }),
            _cache[11] || (_cache[11] = _createTextVNode(" Tambah Fakultas ", -1))
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _cache[15] || (_cache[15] = _createElementVNode("p", { class: "text-sm font-semibold text-slate-500 uppercase tracking-wider" }, "Total Fakultas", -1)),
          _createElementVNode("p", _hoisted_18, _toDisplayString(fakultasList.value.length), 1),
          _cache[16] || (_cache[16] = _createElementVNode("p", { class: "mt-1 text-xs text-slate-500" }, "Seluruh data terdaftar", -1))
        ]),
        _createElementVNode("div", _hoisted_19, [
          _cache[17] || (_cache[17] = _createElementVNode("p", { class: "text-sm font-semibold text-slate-500 uppercase tracking-wider" }, "Aktif", -1)),
          _createElementVNode("p", _hoisted_20, _toDisplayString(activeCount.value), 1),
          _cache[18] || (_cache[18] = _createElementVNode("p", { class: "mt-1 text-xs text-slate-500" }, "Tampil sebagai opsi", -1))
        ]),
        _createElementVNode("div", _hoisted_21, [
          _cache[19] || (_cache[19] = _createElementVNode("p", { class: "text-sm font-semibold text-slate-500 uppercase tracking-wider" }, "Nonaktif", -1)),
          _createElementVNode("p", _hoisted_22, _toDisplayString(inactiveCount.value), 1),
          _cache[20] || (_cache[20] = _createElementVNode("p", { class: "mt-1 text-xs text-slate-500" }, "Disembunyikan dari opsi", -1))
        ])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", null, [
            _cache[22] || (_cache[22] = _createElementVNode("label", { class: "block mb-1.5 text-sm font-semibold text-slate-900" }, "Cari Data", -1)),
            _createElementVNode("div", _hoisted_25, [
              _cache[21] || (_cache[21] = _createElementVNode("span", { class: "absolute inset-y-0 left-0 flex items-center pl-3" }, [
                _createElementVNode("svg", {
                  viewBox: "0 0 24 24",
                  class: "w-4 h-4 text-slate-400",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2"
                }, [
                  _createElementVNode("path", { d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" })
                ])
              ], -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((search).value = $event)),
                placeholder: "Nama atau kode unik...",
                class: "block w-full rounded-lg border border-slate-200 bg-white py-2 pl-10 pr-4 text-sm text-slate-700 placeholder-slate-400 transition-all focus:border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-500/30"
              }, null, 512), [
                [_vModelText, search.value]
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            _cache[23] || (_cache[23] = _createElementVNode("label", { class: "block mb-1.5 text-sm font-semibold text-slate-900" }, "Status", -1)),
            _createVNode(AppSelect, {
              modelValue: statusFilter.value,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((statusFilter).value = $event)),
              options: statusFilterOptions
            }, null, 8, ["modelValue"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("div", _hoisted_27, [
          _cache[24] || (_cache[24] = _createElementVNode("div", null, [
            _createElementVNode("h2", { class: "text-base font-bold text-slate-900" }, "Daftar Fakultas"),
            _createElementVNode("p", { class: "mt-1 text-xs text-slate-500" }, "List referensi kode unik per fakultas.")
          ], -1)),
          _createElementVNode("span", _hoisted_28, "Menampilkan " + _toDisplayString(filteredFakultasList.value.length) + " dari " + _toDisplayString(fakultasList.value.length) + " data", 1)
        ]),
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("table", _hoisted_30, [
            _cache[27] || (_cache[27] = _createElementVNode("thead", null, [
              _createElementVNode("tr", { class: "bg-blue-900" }, [
                _createElementVNode("th", { class: "px-4 py-3.5 text-sm font-semibold text-left text-blue-100 uppercase tracking-wider" }, "Nama Fakultas"),
                _createElementVNode("th", { class: "px-4 py-3.5 text-sm font-semibold text-left text-blue-100 uppercase tracking-wider" }, "Kode Unik"),
                _createElementVNode("th", { class: "px-4 py-3.5 text-sm font-semibold text-left text-blue-100 uppercase tracking-wider" }, "Status"),
                _createElementVNode("th", { class: "px-4 py-3.5 text-sm font-semibold text-center text-blue-100 uppercase tracking-wider" }, "Aksi")
              ])
            ], -1)),
            _createElementVNode("tbody", _hoisted_31, [
              (isLoading.value)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_32, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (c) => {
                      return _createElementVNode("td", {
                        key: c,
                        class: "px-4 py-8"
                      }, [...(_cache[25] || (_cache[25] = [
                        _createElementVNode("div", { class: "h-4 w-full animate-pulse rounded bg-slate-100" }, null, -1)
                      ]))])
                    }), 64))
                  ]))
                : (filteredFakultasList.value.length === 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_33, [...(_cache[26] || (_cache[26] = [
                      _createElementVNode("td", {
                        colspan: "4",
                        class: "px-5 py-12 text-sm text-center text-slate-400 italic"
                      }, "Belum ada data fakultas.", -1)
                    ]))]))
                  : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(filteredFakultasList.value, (item) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: item.id,
                        class: "transition-colors hover:bg-blue-50/40"
                      }, [
                        _createElementVNode("td", _hoisted_34, _toDisplayString(item.name), 1),
                        _createElementVNode("td", _hoisted_35, [
                          _createElementVNode("span", _hoisted_36, _toDisplayString(item.kodeUnik), 1)
                        ]),
                        _createElementVNode("td", _hoisted_37, [
                          _createElementVNode("span", {
                            class: _normalizeClass([item.isActive ? 'bg-emerald-100 text-emerald-700 border-emerald-200' : 'bg-slate-100 text-slate-400 border-slate-200', "rounded-full border px-2.5 py-0.5 text-[11px] font-bold uppercase"])
                          }, _toDisplayString(item.isActive ? 'Aktif' : 'Nonaktif'), 3)
                        ]),
                        _createElementVNode("td", _hoisted_38, [
                          _createElementVNode("div", _hoisted_39, [
                            _createElementVNode("button", {
                              class: "p-1.5 text-amber-600 hover:bg-amber-50 rounded-lg transition-colors",
                              title: "Edit",
                              onClick: ($event: any) => (openEdit(item))
                            }, [
                              _createVNode(IcEdit, { class: "w-4 h-4" })
                            ], 8, _hoisted_40),
                            _createElementVNode("button", {
                              class: "p-1.5 text-red-600 hover:bg-red-50 rounded-lg transition-colors",
                              title: "Hapus",
                              onClick: ($event: any) => (handleDelete(item))
                            }, [
                              _createVNode(IcTrash, { class: "w-4 h-4" })
                            ], 8, _hoisted_41)
                          ])
                        ])
                      ]))
                    }), 128))
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})